/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import _ from 'lodash';
import { selectAuthUserData } from '../../redux/features/auth/auth.slice';
import { RoutePath } from '../enums/RoutePath';
import { isRoleValid } from '../../redux/features/auth/auth.helper';

export const useIsAuthorized = () => {
  const location = useLocation();
  const { submissionId } = useParams();
  const { roles: userRoles = [], extraRoles: userExtraRoles = [], current_org_id: userCurrentOrgId = '' } = useSelector(
    selectAuthUserData,
  );

  const routePath = RoutePath.getRoutePath(location?.pathname);

  if (RoutePath.isUmaRoute(location?.pathname)) {
    const userExtraRole = userExtraRoles.find(_extraRole => _extraRole.submissionId === submissionId);
    const isUserExtraRoleValid = userExtraRole?.roles.some(_extraRole => routePath.roles?.includes(_extraRole));
    const isUserOrgSameTenantId = userExtraRole?.tenantId === userCurrentOrgId;

    return isUserExtraRoleValid && !isUserOrgSameTenantId;
  }

  return !_.isEmpty(userRoles) && isRoleValid(userRoles, routePath.roles);
};
